import React from 'react';

import useTheme from '@hero/branding/theme';
import { IconComponentProps } from '@hero/ui-kit/types';

const ThumbDownIcon: React.FC<IconComponentProps> = ({
    type = 'utility',
    size = 'regular',
    disabled = false,
    styles,
    color = 'currentColor',
    ...rest
}) => {
    const { sizing } = useTheme();
    const sizePx = sizing.widths.icon[size];

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            width={sizePx}
            height={sizePx}
            style={styles}
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...rest}
        >
            <path d="M17 14V2" />
            <path d="M9 18.12L10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88z" />
        </svg>
    );
};

export default ThumbDownIcon;
